/** Joins class names, dropping falsy entries (prototype markup relies on plain class lists). */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter((p): p is string => typeof p === 'string' && p.length > 0).join(' ');
}
